import { render } from "./MaterialAvatar.vue?vue&type=template&id=6d08cf9a"
import script from "./MaterialAvatar.vue?vue&type=script&lang=js"
export * from "./MaterialAvatar.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/workspace/Deploy unapatitafeliz backend PROD/admin-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__